import { useState } from 'react'
import { useAlert } from 'react-alert'
import alertImage from '../../assets/images/alert.gif'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import { Button } from '..'
import { DeleteStyled } from './styles'
import { deleteRelevantFact } from '../../../main/usecases/services/relevantfact'
import { RelevantFactModel } from '../../../domain/models/relevant-fact'

const DeleteRelevantFact = ({
  item
}: {
  item: RelevantFactModel | undefined
}) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteService = async (id: any) => {
    try {
      setLoading(true)
      await deleteRelevantFact({
        id: id
      }).delete()
      modalClose(true)
      alert.show('Fato relevante deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      modalClose(true)
      setRefresh((prev: any) => !prev)
      console.error(error)
      alert.show('Erro ao deletar um Fato relevante', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <DeleteStyled className="delete-modal">
      <img src={alertImage} />
      <div className="content">
        <p>
          Deseja realmente deletar esse Fato Relevante? Essa ação não poderá ser
          revertida.
        </p>
        <div className="actions">
          <Button
            hasredButton
            onClick={() => handleDeleteService(item?.cdFatoRelevante)}
            disabled={loading}
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>
    </DeleteStyled>
  )
}

export default DeleteRelevantFact
